import { useUiConfig } from 'api/uiConfig/uiConfig.api'
import authStore from 'store/auth/auth'
import { useSnapshot } from 'valtio'
import { INTRADAY_OVERVIEW_ANCHOR, INTRADAY_TRADING_VIEW_ANCHOR } from '../../IntradayTradingView.helpers'

type IntradayUiConfigAvailability = {
  isOptimizeConfigured: boolean
  isOverviewConfigured: boolean
  isLoading: boolean
}

export function useIntradayUiConfigAvailability(systemId: number | undefined | null): IntradayUiConfigAvailability {
  const isBeta = useSnapshot(authStore).isBeta
  const mode = isBeta ? 'beta' : null
  const { data: optimizeConfigs, isLoading: isOptimizeLoading } = useUiConfig(systemId, INTRADAY_TRADING_VIEW_ANCHOR, {
    mode,
  })
  const { data: overviewConfigs, isLoading: isOverviewLoading } = useUiConfig(systemId, INTRADAY_OVERVIEW_ANCHOR, {
    mode,
  })

  return {
    isOptimizeConfigured: Boolean(optimizeConfigs?.some((config) => config.component === INTRADAY_TRADING_VIEW_ANCHOR)),
    isOverviewConfigured: Boolean(overviewConfigs?.some((config) => config.component === INTRADAY_OVERVIEW_ANCHOR)),
    isLoading: isOptimizeLoading || isOverviewLoading,
  }
}
